import {
    ApolloClient,
    ApolloLink,
    concat,
    from,
    HttpLink,
    InMemoryCache
} from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import type { GraphQLFormattedError } from 'graphql'
import { getAuthToken, getLogoutPath } from '@core/lib/cache'

type TGraphQLError =
    | ReadonlyArray<
          GraphQLFormattedError & {
              code?: string
              message?: string
              isTrusted?: boolean
          }
      >
    | undefined

const uri = process.env.ENDPOINT
    ? `${process.env.ENDPOINT}/graphql`
    : `http://localhost:8080/graphql`

const httpLink = new HttpLink({ uri })

const authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext(({ headers = {} }) => {
        return {
            headers: {
                ...headers,
                authorization: getAuthToken()
            }
        }
    })

    return forward(operation)
})

const errorLink = onError(({ graphQLErrors }) => {
    if (graphQLErrors) {
        const errors: TGraphQLError = graphQLErrors

        const noAccess = errors.find(err => err.code === 'NO_PERSON_ACCESS')

        if (noAccess) {
            const path = window.location.pathname

            if (path.includes('home') || path.includes('my-account')) {
                location.replace(getLogoutPath())
            }

            return
        }
    }
})

export const apolloClient = new ApolloClient({
    cache: new InMemoryCache(),
    link: from([errorLink, concat(authMiddleware, httpLink)])
})
